import producer from 'immer';
import { PHOTO_SESSION_ISSUE_REPORT_ACTION, PHOTO_SESSION_ISSUE_REPORT_UPDATE } from './types';
import { handleIssueReport, updateIssueReportError } from './handlers';

export const initialState = {
  hasReportError: false,
  isIssueReported: false,
  isDialogLoading: false,
};

export const issueReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case PHOTO_SESSION_ISSUE_REPORT_ACTION:
      return handleIssueReport(state, action);
    case PHOTO_SESSION_ISSUE_REPORT_UPDATE:
      return updateIssueReportError({ state, action });
    default:
      return state;
  }
};

export default producer(issueReportReducer);
